import {Component, Inject, OnInit} from '@angular/core';
import {ProjectId} from '@webmate-web-core/shared/types/ids';
import {DeviceService} from '@webmate-web-core/shared/services/device/device.service';
import {DeviceSlot} from '@webmate-web-core/shared/types/devices/device-slot';
import {WmNotificationService} from '@webmate-web-core/shared/components/notification/wm-notification.service';
import {ModalToolContainerService, WebmateToolConfig} from '../modaltoolcontainer/modaltoolcontainer.service';
import {TOOL_CONTAINER_DATA} from '../modaltoolcontainer/modaltoolcontainer.component';
import {UntilDestroy} from '@ngneat/until-destroy';


export class UpdateRequestToolConfig implements WebmateToolConfig {
    toolName = 'Request Device Update';

    constructor(public slot: DeviceSlot, public openSTFSerial: string, public modelName: string, public currentVersion: string, public projectId: ProjectId) {
    }
}

@UntilDestroy()
@Component({
    templateUrl: './update-request.component.html',
    styleUrls: ['./update-request.component.less']
})
export class UpdateRequestToolComponent {

    message: string = '';
    busySendingReport = false;

    constructor(@Inject(TOOL_CONTAINER_DATA) public data: UpdateRequestToolConfig,
                private deviceService: DeviceService,
                private notificationService: WmNotificationService,
                private toolService: ModalToolContainerService) {
    }

    requestUpdate() {
        this.busySendingReport = true;
        this.deviceService.requestDeviceUpdate(this.data.slot.id, this.data.openSTFSerial, this.data.currentVersion, this.message, this.data.projectId).subscribe(
            next => {
                setTimeout(() => this.toolService.closeLastTool(), 0);
                this.notificationService.toastNotification('Device update request sent successfully.');
            },
            err => {
                setTimeout(() => this.toolService.closeLastTool(), 0);
                this.notificationService.toastWarningNotification('Sending device update request failed.');
            }
        );
    }
}
